module.exports = __webpack_public_path__ + "static/media/not-yet-transcribed.e67575ac.txt";